import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';

const stories = [
  {
    category: 'Military Family Support',
    image: 'https://images.unsplash.com/photo-1529156069898-49953e39b3ac?auto=format&fit=crop&w=600&q=80',
    quote: "When my husband was overseas, I didn't know how we'd make it. These people showed up for us.",
    name: 'The Martinez Family',
  },
  {
    category: 'Youth Mentoring',
    image: 'https://images.unsplash.com/photo-1531545514256-b1400bc00f31?auto=format&fit=crop&w=600&q=80',
    quote: "This program didn't just give me skills. It gave me someone who believed in me before I believed in myself.",
    name: 'Marcus T.',
  },
  {
    category: 'Veteran Transition Support',
    image: 'https://images.unsplash.com/photo-1559027615-cd4628902d4a?auto=format&fit=crop&w=600&q=80',
    quote: "They didn't just hand me something and walk away. They walked with me through the whole process.",
    name: 'Specialist Williams',
  },
];

const StoriesOfImpactSection = () => {
  return (
    <section className="py-24 bg-[#FAF9F6]" data-testid="stories-impact-section">
      <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-24">
        {/* Header */}
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <p className="text-xs font-bold tracking-[0.25em] uppercase text-amber-700 mb-4">
            Voices From Our Community
          </p>
          <h2 className="text-4xl sm:text-5xl font-medium text-[#0B1120] tracking-tight mb-6 font-serif">
            Stories of Impact
          </h2>
          <p className="text-lg text-slate-600 font-light max-w-2xl mx-auto">
            Behind every number is a real person. These are some of the families and 
            individuals whose lives have been changed.
          </p>
        </motion.div>

        {/* Stories Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          {stories.map((story, idx) => (
            <motion.div
              key={story.name}
              className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-lg transition-shadow"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: idx * 0.15 }}
            >
              {/* Image */}
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={story.image}
                  alt={story.category}
                  className="w-full h-full object-cover"
                />
              </div>
              
              {/* Content */}
              <div className="p-6">
                <p className="text-xs font-bold tracking-[0.2em] uppercase text-amber-600 mb-3">
                  {story.category}
                </p>
                
                {/* Quote marks */}
                <div className="text-amber-400 text-4xl font-serif leading-none mb-2">"</div>
                
                <p className="text-slate-700 italic font-light leading-relaxed mb-4">
                  {story.quote}
                </p>
                
                {/* Divider */}
                <div className="w-8 h-0.5 bg-slate-300 mb-3" />
                
                <p className="font-semibold text-slate-800">
                  {story.name}
                </p>
              </div>
            </motion.div>
          ))}
        </div>

        {/* CTA Link */}
        <motion.div
          className="text-center"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
        >
          <button className="inline-flex items-center gap-2 text-slate-600 hover:text-[#1E3A8A] font-medium transition-colors group">
            See all our community stories
            <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
          </button>
        </motion.div>
      </div>
    </section>
  );
};

export default StoriesOfImpactSection;
